function updateViewport() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}
updateViewport();
window.addEventListener("resize", updateViewport);
